import { Link } from '@/components/common/Link';
import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
export default function CompositeDeckingFeature() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && contentRef.current) {
          contentRef.current.classList.remove("opacity-0", "translate-y-8");
          contentRef.current.classList.add("opacity-100", "translate-y-0");
        }
      });
    }, {
      threshold: 0.2
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  return;
}